import View from '../Support/View/View';

export default class CookieConsent extends View {
    #COOKIE_VALUE  = 1;
    #COOKIE_DOMAIN = null;
    #data          = null;

    static get viewName() {
        return 'cookie-consent';
    }
    static get viewType() {
        return 'component';
    }

    start() {
        this.#data          = this.viewData;
        this.#COOKIE_VALUE  = 1;
        this.#COOKIE_DOMAIN = this.#data.domain;

        if (this.#cookieExists(this.#data.name)) {
            this.#hideCookieDialog();

            return;
        }

        this.#markAsLoaded();
        this.#handleConsent();
    }

    #markAsLoaded() {
        setTimeout(() => this.$el.classList.add('is-loaded'), 1300);
    }
    #handleConsent() {
        const button = this.$el.querySelector('.cookie-consent-agree');

        const onClick = () => {
            this.#consentWithCookies();

            button?.removeEventListener('click', onClick);
        };

        button?.addEventListener('click', onClick);
    }

    #consentWithCookies() {
        this.#setCookie(this.#data.name, this.#COOKIE_VALUE, this.#data.lifetime);

        this.#hideCookieDialog();
    }
    #cookieExists(name) {
        return (document.cookie.split('; ').indexOf(name + '=' + this.#COOKIE_VALUE) !== -1);
    }
    #hideCookieDialog() {
        this.$el.style.display = 'none';
    }
    #setCookie(name, value, expirationInDays) {
        const date = new Date();

        date.setTime(date.getTime() + (expirationInDays * 24 * 60 * 60 * 1000));

        document.cookie = (
            `${name}=${value}`
            + `;expires=${date.toUTCString()}`
            + `;domain=${this.#COOKIE_DOMAIN}`
            + ';path=/'
            + (this.#data.secure ? ';secure' : '')
            + (this.#data.same_site ? `;samesite=${this.#data.same_site}` : '')
        );
    }
}